// offset between uppercase ascii and regional indicator symbols
const OFFSET = 127397;

const languageCountry = {
  EN: 'GB',
};

export function supportsFlagEmoji() {
  const canvas =
    typeof document !== 'undefined' && document.createElement('canvas');
  if (canvas) {
    canvas.height = 10;
    canvas.width = canvas.height * 2;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.font = canvas.height + 'px Arial';
      ctx.fillText('🇬🇧', 0, canvas.height);
      const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let i = 0;
      while (i < data.length) {
        if (data[i] !== data[i + 1] || data[i] !== data[i + 2]) return true;
        i += 4;
      }
    }
  }
  return false;
}

/**
 * convert country code to corresponding flag emoji
 * @param {string} cc - country code string
 * @returns {string} flag emoji
 */
export function countryCodeToFlagEmoji(cc: string) {
  if (!supportsFlagEmoji()) {
    return '';
  }

  if (!cc) {
    return '';
  }

  const country = cc.toUpperCase();
  const flagCode =
    languageCountry[country as keyof typeof languageCountry] || country;

  const codePoints = Array.from(flagCode).map(
    c => c.codePointAt(0)! + OFFSET,
  );

  return String.fromCodePoint(...codePoints);
}
